export function addTransactionCard(info) {
    const card = document.createElement('div');
    card.classList.add('user-card-default__loyality-transactions__item');
    const dateToDate = new Date(info.date);
    let newInnerHTML = info.type === 'CHARGE' ? `
        <div class="user-card-default__loyality-transactions__item__icon-block">
            <div class="user-card-default__loyality-transactions__item__icon plus">
                <svg width="31" height="30" viewBox="0 0 31 30" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.625 7.125C16.625 6.82663 16.5065 6.54048 16.2955 6.3295C16.0845 6.11853 15.7984 6 15.5 6C15.2016 6 14.9155 6.11853 14.7045 6.3295C14.4935 6.54048 14.375 6.82663 14.375 7.125V13.875H7.625C7.32663 13.875 7.04048 13.9935 6.8295 14.2045C6.61853 14.4155 6.5 14.7016 6.5 15C6.5 15.2984 6.61853 15.5845 6.8295 15.7955C7.04048 16.0065 7.32663 16.125 7.625 16.125H14.375V22.875C14.375 23.1734 14.4935 23.4595 14.7045 23.6705C14.9155 23.8815 15.2016 24 15.5 24C15.7984 24 16.0845 23.8815 16.2955 23.6705C16.5065 23.4595 16.625 23.1734 16.625 22.875V16.125H23.375C23.6734 16.125 23.9595 16.0065 24.1705 15.7955C24.3815 15.5845 24.5 15.2984 24.5 15C24.5 14.7016 24.3815 14.4155 24.1705 14.2045C23.9595 13.9935 23.6734 13.875 23.375 13.875H16.625V7.125Z"
                            fill="#0BD20B"/>
                </svg>
            </div>
            + ${info.amount / 100} ₽
        </div>
        <div class="user-card-default__loyality-transactions__item__text">
            ${naturalDay(dateToDate)}${dateToDate.toLocaleDateString('ru-RU').slice(0, 5)}
        </div>
    ` : `
        <div class="user-card-default__loyality-transactions__item__icon-block">
            <div class="user-card-default__loyality-transactions__item__icon minus">
                <svg xmlns="http://www.w3.org/2000/svg" width="31" height="30"
                        viewBox="0 0 31 30" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.5 15C6.5 14.7016 6.61853 14.4155 6.8295 14.2045C7.04048 13.9935 7.32663 13.875 7.625 13.875H23.375C23.6734 13.875 23.9595 13.9935 24.1705 14.2045C24.3815 14.4155 24.5 14.7016 24.5 15C24.5 15.2984 24.3815 15.5845 24.1705 15.7955C23.9595 16.0065 23.6734 16.125 23.375 16.125H7.625C7.32663 16.125 7.04048 16.0065 6.8295 15.7955C6.61853 15.5845 6.5 15.2984 6.5 15Z"
                            fill="#ED1C24"/>
                </svg>
            </div>
            - ${info.amount / 100} ₽
        </div>
        <div class="user-card-default__loyality-transactions__item__text">
            ${dateToDate.toLocaleDateString('ru-RU').slice(0, 5)}
        </div>
    `;
    card.innerHTML = newInnerHTML;
    return card;
}

function naturalDay(givenDate) {
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    const diffInTime = givenDate.getTime() - today.getTime();
    const diffInDays = diffInTime / (1000 * 60 * 60 * 24);

    if (diffInDays === 0) {
        return "Сегодня, ";
    } else if (diffInDays === -1) {
        return "Вчера, ";
    } else {
        return '';
    }
}